import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { ReservationSettingsComponent } from '../reservation-settings/reservation-settings.component';
import { VesselAvailabilityDialogService } from './vessel-availability-dialog.service';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ProductOfferingFormComponent } from '../product-offering-form/product-offering-form.component';

@NgModule({
  declarations: [ReservationSettingsComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatRadioModule,
    FormsModule,
    MatSelectModule,
    MatIconModule,
    MatProgressSpinnerModule,
  ],
  entryComponents: [ReservationSettingsComponent],
  providers: [VesselAvailabilityDialogService],
  exports: [ReservationSettingsComponent],
})
export class VesselAvailabilityDialogModule {}
